window.addEventListener('OpusCartChange', (event)=>{
  if (!document.querySelector('.opus-extra-text')) {
    document.querySelector('.drawer-cd-up-app-Ksl-header').insertAdjacentHTML(
      "afterend",
      ` <div class="opus-extra-text" style="width: 100%; display: flex; justify-content: center; background: #eee; font-weight: bold; padding: 10px">
          BUY 3 GET 4 FREE GIFTS
      </div>`
    );
  }

  document.querySelectorAll('.cd-buy-button.cd-main-button').forEach(button => {
    let svgIcon = button.querySelector('svg'); 
    if (svgIcon) {
      svgIcon.remove();
    }
    
    button.textContent = 'ADD';
    button.style.fontWeight = 'bold'; 
    button.style.fontSize = '10px'; 
    button.style.textTransform = 'uppercase';
  });

  const button = document.querySelector(".cd-buy-button");
    if (button) button.innerHTML = "Add";

    const existingContainer = document.querySelector(".opus-price-ct-container");
    if (existingContainer) {
        existingContainer.remove();
    }

    let original_total_price = 0;
    let money = 0;
    let countItem = 0;
    const items = document.querySelectorAll('.cd-section-price');

    items.forEach((item) => {
        const originalPriceEl = item.querySelector('.cd-original-price');
        const moneyEl = item.querySelector('.money');

        const itemMoney = moneyEl ? parseFloat(moneyEl.textContent.replace(/[^\d-]/g, '')) || 0 : 0;
        const itemOriginalPrice = originalPriceEl ? parseFloat(originalPriceEl.textContent.replace(/[^\d-]/g, '')) || 0 : 0;

        original_total_price += itemOriginalPrice || itemMoney;
        money += itemMoney;
    });

    const itemsCount = document.querySelectorAll('.cd-number-input');
    itemsCount.forEach((item) => {
        const inputField = item.querySelector('.cd-number-input-field');
        const originalCount = inputField ? parseInt(inputField.value) || 0 : 0;
        countItem += originalCount;
    });

    console.log("discountdiscountdiscount", countItem);

    let discount = original_total_price - money;
    const hasDiscount = discount > 0;

    document.querySelectorAll('.opus-price-ct-container').forEach(el => el.remove());

    const checkoutBtn = document.querySelector(".opus-btn-checkout");
    if (!checkoutBtn) return; // Kiểm tra nếu checkoutBtn không tồn tại

    // Kiểm tra reward settings
    const rewards = window.CartDrawerAppSettings?.settings?.cart_drawer?.rewards?.rewardSettings || [];
    const freeShippingReward = rewards.find(reward => reward.rewardType === "Shipping");

    let shippingMessage = "";
    if (freeShippingReward) {
        const minRequired = parseInt(freeShippingReward.miniumAmount, 10);
        const remaining = countItem - minRequired; 

        if (remaining >= 0) {
            shippingMessage = `<div style="display: flex; justify-content: space-between; font-size: 14px;">
                <span style="color: black;">Shipping</span>
                <span style=" color: black;font-weight: bold;">FREE</span>
            </div>`;
        } 
    }

    checkoutBtn.insertAdjacentHTML(
        "beforebegin",
        `<div class="opus-price-ct-container" style="width: 100%; padding-top: 5px; font-size: 16px; text-transform: uppercase; margin: auto;">
            <div style="display: flex; justify-content: space-between; font-weight: bold; padding-bottom: 5px;">
                <span style="color: black;">Subtotal</span>
                <span style="color: black;">${ window.OpusConvertMoney(money.toFixed(2))}</span>
            </div>
    
            ${shippingMessage}
        </div>`
    );

     if (!document.querySelector(".opus-extra-image") && checkoutBtn) {
          checkoutBtn.insertAdjacentHTML(
              "afterend",
              `<div class="opus-extra-image" 
                   style="width: 100%; display: flex; justify-content: center; 
                          align-items: center; gap: 10px; margin-top: 16px">
                  <span style="font-size: 13px; font-weight: bold; color: #333;">
                      100% Satisfaction Guarantee Or Your Money Back!
                  </span>
              </div>`
          );
      }
});

